import React, { useState } from "react";
import { Form, Button, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DateTimePicker from "react-datetime-picker";
import { useToasts } from "react-toast-notifications";
import {
  serviceActions,
  useServiceReducer,
} from "../../../reducers/serviceReducer";

import EntityHistoryResult from "./EntityHistoryResult";
import CheckEntityForm from "./CheckEntityForm";
import { entityHistory } from "../../../services/Results";

export default function EntityQueryBox() {
  const { addToast } = useToasts();
  const [entity, setEntity] = useState(null);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [result, setResult] = useState(null);
  const [serviceState, serviceDispatch] = useServiceReducer();

  function EntityAnalysisForm() {
    return (
      <>
        <h5>Choose time period:</h5>
        <Form>
          <Form.Row>
            <Form.Group as={Col} controlId="form.startDate">
              <Form.Label>From</Form.Label>
              <DateTimePicker
                maxDetail="second"
                className="form-control"
                onChange={setStartDate}
                value={startDate}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="form.endDate">
              <Form.Label>To</Form.Label>
              <DateTimePicker
                maxDetail="second"
                className="form-control"
                onChange={setEndDate}
                value={endDate}
              />
            </Form.Group>
          </Form.Row>
          <Button
            variant="outline-primary"
            disabled={serviceState.loading}
            onClick={() => {
              submitForm();
            }}
          >
            Get sentiment history for <em>{entity}</em>
          </Button>
        </Form>
      </>
    );
  }
  function checkDates() {
    if (startDate > endDate) {
      let temp = startDate;
      setStartDate(endDate);
      setEndDate(temp);
    }
  }
  async function submitForm() {
    serviceDispatch({ type: serviceActions.LOADING });
    setResult(null);
    checkDates();
    try {
      const result = await entityHistory(entity, startDate, endDate);
      // console.log("RESULT", result);
      serviceDispatch({ type: serviceActions.SUCCESS });
      addToast("Success", { appearance: "success" });
      setResult(result);
    } catch (err) {
      console.log("error", err);
      serviceDispatch({ type: serviceActions.ERROR, payload: err.message });
      addToast(`System error: ${err.message}`, { appearance: "error" });
    }
  }

  return (
    <div className="card mb-4 ">
      <div className="card-header">
        <FontAwesomeIcon icon="chart-area" className="mr-1" />
        Entity Sentiment History
      </div>
      <div className="card-body">
        <CheckEntityForm
          onSelectEntity={(entity) => {
            setEntity(entity);
          }}
        />
        <hr />
        {entity ? <EntityAnalysisForm /> : null}
        {result ? (
          <div>
            <hr />
            <EntityHistoryResult entity={entity} result={result} />
          </div>
        ) : null}
      </div>
    </div>
  );
}
